import AppEnv from './AppEnv';

export const AppLinkingPrefixes = [
  AppEnv.appSchemaPrefix,
  ...AppEnv.associatedDomains.map((domain: string) => `https://${domain}`),
];
